export default __webpack_public_path__ + "static/media/Footer-Logo.a91c320d.svg";